import * as TemplateTypes from 'types/template.types';
import BaseScene from './base';
import PointerWaveFX from 'fx/pointer/wave';
import ExpandingSpritesBackgroundFx from 'src/fx/background/expanding-sprites';
import WarpPipelinePlugin from 'phaser3-rex-plugins/plugins/warppipeline-plugin.js';
import { useModule } from 'src/modules/modules';

class Menu extends BaseScene {

    private fx: ExpandingSpritesBackgroundFx | null = null;

    constructor(){
        super({ 
            key: TemplateTypes.Scene.MENU, 
            trackKey: 'MUSIC_game',
            transition: {
                scene: {
                    enter: {
                        name: 'fade',
                        duration: 500
                    },
                    exit: {
                        name: 'fade',
                        duration: 500
                    },
                },
                menu: {
                    exit: {
                        name: 'fade-scale',
                        duration: 500
                    },
                    enter: {
                        name: 'fade-scale',
                        duration: 500
                    }
                },
                audio: {
                    exit: {
                        name: 'detune',
                        duration: 500
                    },
                    enter: {
                        name: 'fade',
                        duration: 500
                    }
                }
            }
        });
    }

    async create(){
        super.enter();

        // this.fx = new ExpandingSpritesBackgroundFx(this, 'FX_pointer_wave_filled', [
        //     0x0bf3f0,
        //     0x21dbf2,
        //     0x41b8f4,
        //     0x2dcef2,
        //     0x4bacf4,
        //     0x56a1f5,
        //     0x787cf7,
        //     0x8f64f9,
        //     0xa748fa,
        //     0xb738fc,
        //     0xd516fd,
        //     0xe00bfe,
        //     0x0bfe61,
        //     0x00ffc4
        // ]);
        this.fx = null;
        this.updateBgFx();
        new PointerWaveFX(this, 'FX_pointer_wave');
        let pipelineInstance  = ( <WarpPipelinePlugin> this.plugins.get('rexWarpPipeline'))
            .add(<Phaser.GameObjects.GameObject> <unknown> this.cameras.main, {
                speedEnable: true,
                speedY: 2,
                frequencyX: 10,
                frequencyY: 10,
                amplitudeX: 10,
                amplitudeY: 10,
            })
    }

    updateBgFx(){
        const { theme } = useModule();
        let tints = theme.getSetAsTint('backgroundFX');
        if (!this.fx){
            this.fx = new ExpandingSpritesBackgroundFx(this, 'FX_pointer_wave_filled', tints);
        } else {
            this.fx.setPalette(tints);
        }
    }
}

export default Menu;